export function decodeJwt(token: string) {
    function base64UrlDecode(a: string) {
        let b = a.replace(/-/g, '+').replace(/_/g, '/');
        switch (b.length % 4) {
            case 0:
                break;
            case 2:
                b += '==';
                break;
            case 3:
                b += '=';
                break;
            default:
                throw new Error('Illegal base64url string!');
        }

        const c = window.atob(b);
        try {
            return decodeURIComponent(escape(c));
        } catch {
            return c;
        }
    }

    const segments = token.split('.');

    if (segments.length !== 3) {
        throw new Error('Not enough or too many segments');
    }

    const header = JSON.parse(base64UrlDecode(segments[0]));
    const payload = JSON.parse(base64UrlDecode(segments[1]));

    return {
        header,
        payload,
        signature: segments[2]
    };
}
